import * as React from 'react';
import Header from '@component/Header'
import Bottom from '@component/Bottom'
// import { Link } from 'react-router-dom';
import { JDList } from '@src/constants'
import './style.scss'

export interface IJoinUsStates {
  current: number,
  detailIndex: number
}

export default class JoinUs extends React.Component<any, IJoinUsStates> {

  constructor(props: any) {
    super(props)
    this.state = {
      current: 1,
      detailIndex: -1
    }
    this.getDetailList = this.getDetailList.bind(this);
    this.formateData = this.formateData.bind(this);
  }

  public componentDidMount() {
    document.title = "域起火爆棋牌游戏-经典捕鱼游戏-域起精品手游"
    document.getElementsByTagName("meta")[4].content = '域起官网,域起精品手游,热门棋牌游戏平台,火爆捕鱼游戏'
    document.getElementsByTagName("meta")[5].content = '上海域起网络科技有限公司是中国领先的游戏开发商。公司主要业务集中在互联网手机游戏，互联网应用等领域 。公司旗下产品有《哥哥游戏平台》,《哥哥捕鱼》,《梦幻炫舞》,《青空之刃》等诸多精品手游。'
    scrollTo(0, 0)
  }

  public changeCurrent(current: number) {
    this.setState({ current, detailIndex: -1 })
  }

  public openDeatil(detailIndex: number) {
    if (detailIndex === this.state.detailIndex) {
      this.setState({ detailIndex: -1 });
    } else {
      this.setState({ detailIndex });
    }
  }

  public formateData(item: any, key: number) {
    return (
      <div key={key} className="every-detail">
        <img onClick={this.openDeatil.bind(this, key)} className={`arrow-base ${this.state.detailIndex === key ? 'arrow-open' : ''}`} src={require("@static/arrow.png")} alt="域起官网" />
        <div className="every-detail-title">{item.title}</div>
        <div className="require-diy-style">岗位职责:</div>
        {item.responsibilities.map((itemDetail: any, keyDetail: number) => {
          return (
            <div key={keyDetail} className="responsibilities-style">{itemDetail}</div>
          )
        })}
        {
          this.state.detailIndex === key
            ? <div className="require-diy-style">任职要求:</div>
            : ''
        }
        {
          this.state.detailIndex === key
            ? item.requirements.map((itemRequirements: any, keyRequire: number) => {
              return (
                <div key={keyRequire} className="responsibilities-style">{itemRequirements}</div>
              )
            })
            : ''
        }
      </div>
    )
  }

  public getDetailList() {
    switch (this.state.current) {
      case 1:
        return JDList.developer.map((item, key) => {
          return this.formateData(item, key)
        })
        break;
      case 2:
        return JDList.product.map((item, key) => {
          return this.formateData(item, key)
        })
        break;
      case 3:
        return JDList.design.map((item, key) => {
          return this.formateData(item, key)
        })
        break;
      default:
        return JDList.developer.map((item, key) => {
          return this.formateData(item, key)
        })
        break;
    }
  }

  public render() {
    return (
      <div className="pc-join-us">
        <Header />
        <img className="header-img" src={require('@static/20190916-join-pc.jpg')} alt="域起官网" />
        <div className="main-content">
          {/* <div className="nav-about-us"><Link to={{ pathname: `/` }}>首页</Link>> 加入我们</div> */}
          <div className="title-style">我们需要你的加入！</div>
          <div className="mail-style">简历投递：campus@gg.com</div>
          <div className="join-us-label">
            <span className={this.state.current === 1 ? 'current-bg' : ''} onClick={this.changeCurrent.bind(this, 1)}>研发类</span>
            <span className={this.state.current === 2 ? 'current-bg' : ''} onClick={this.changeCurrent.bind(this, 2)}>产品类</span>
            <span className={this.state.current === 3 ? 'current-bg' : ''} onClick={this.changeCurrent.bind(this, 3)}>设计类</span>
          </div>
          <div className="jd-title">职位</div>
          {this.getDetailList()}
        </div>
        <Bottom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JoinUs/index.tsx